import { useContext } from 'react';
import { RealtimeContext } from './RealtimeContext';

/** True while the realtime socket of the tab is connected. False with no provider. */
export function useRealtimeConnected(): boolean {
  return useContext(RealtimeContext).isConnected;
}
